/**
=========================================================
* Trust Cargo - outlined, standard and filled inputs
=========================================================

* The three MUI variants share the box drawn in inputBase.js. All this
* adds is what the variant itself would otherwise draw over it: the
* outlined frame (with the notch cut for a label sitting on the border -
* the label sits above the box here, so there is nothing to cut round),
* and the underline of the standard variant.
*/

import pxToRem from "assets/theme/functions/pxToRem";

const input = {
  styleOverrides: {
    root: {
      display: "flex !important",
      padding: `${pxToRem(8)} ${pxToRem(12)} !important`,

      "&.MuiInputBase-sizeSmall": {
        padding: `${pxToRem(5)} ${pxToRem(10)} !important`,
      },

      // the frame is inputBase's border - MUI's own outline would be a second one
      "& fieldset": {
        border: "none",
      },
      "&:before, &:after": {
        display: "none",
      },
    },

    input: {
      height: pxToRem(22),
      width: "100% !important",
    },

    inputSizeSmall: {
      height: pxToRem(22),
    },
  },
};

export default input;
